import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { GrIconButton } from "../buttons";
import { GrIcon } from "../icons";
import { GrCheckbox, GrHelperMessage, GrLabel, StyledSelectOptionTypography } from ".";
import { GrStack } from "../layout";
import { palette } from "../../theme/palette";
import { typography } from "../../theme/typography";
import { Autocomplete, Paper, styled, } from "@mui/material";
import TextField from "@mui/material/TextField";
import classNames from "classnames";
import { useState } from "react";
import { GrChip, GrTooltip } from "../data/data-display";
const StyledAutocomplete = styled(Autocomplete)(({ size, style, disabled, readOnly }) => {
    var _a, _b, _c, _d, _e, _f;
    return {
        width: "100% !important",
        ".MuiInputBase-root": {
            ...(size === "large" && {
                padding: "9px 8px",
            }),
            ...(size === "medium" && {
                padding: "6px 8px",
            }),
            ...(size === "small" && {
                padding: "3px 8px",
            }),
            ...typography[size === "large" ? "Content.Subtitle02" : size === "medium" ? "Content.Subtitle03" : "Content.Subtitle04"],
            minHeight: size === "large" ? "40px" : size === "medium" ? "32px" : "24px",
            display: "flex",
            alignItems: "center",
            padding: (style === null || style === void 0 ? void 0 : style.padding) || (size === "large" && "9px 8px") || (size === "medium" && "6px 8px") || undefined,
            gap: "6px",
            borderRadius: (_a = style === null || style === void 0 ? void 0 : style.borderRadius) !== null && _a !== void 0 ? _a : "6px",
            backgroundColor: disabled || readOnly ? palette.bg010 : palette.white,
            ".Mui-disabled": {
                WebkitTextFillColor: palette.grey030,
            },
        },
        ".MuiInputBase-input": {
            width: "100%",
            padding: "0px 2px !important",
            overflow: "auto !important",
            border: "none",
            borderWidth: "0",
            ...typography[size === "large" ? "Content.Subtitle02" : size === "medium" ? "Content.Subtitle03" : "Content.Subtitle04"],
            caretColor: (_b = style === null || style === void 0 ? void 0 : style.caretColor) !== null && _b !== void 0 ? _b : palette["maven-blue-dark"],
            color: (_c = style === null || style === void 0 ? void 0 : style.color) !== null && _c !== void 0 ? _c : ((readOnly && palette.grey060) || (disabled && palette.grey030) || palette.grey090),
            "&::-webkit-scrollbar": {
                width: 8,
                backgroundColor: "transparent",
            },
            "&::-webkit-scrollbar-thumb": {
                backgroundColor: palette.grey030,
                borderRadius: 8,
            },
            "&::-webkit-scrollbar-track": {
                backgroundColor: "transparent",
            },
            ...style,
        },
        ".MuiOutlinedInput-notchedOutline": {
            borderWidth: !(style === null || style === void 0 ? void 0 : style.border) ? (_d = style === null || style === void 0 ? void 0 : style.borderWidth) !== null && _d !== void 0 ? _d : "1px !important" : undefined,
            borderColor: !(style === null || style === void 0 ? void 0 : style.border) ? (_e = style === null || style === void 0 ? void 0 : style.borderColor) !== null && _e !== void 0 ? _e : palette.grey025 : undefined,
            border: style === null || style === void 0 ? void 0 : style.border,
        },
        ":hover": {
            ".MuiOutlinedInput-notchedOutline": {
                border: !readOnly && !disabled && `1px solid ${palette.grey040} !important`,
            },
        },
        ".Mui-focused": {
            ".MuiOutlinedInput-notchedOutline": {
                border: !readOnly && !disabled && `1px solid ${palette["maven-blue-dark"]} !important`,
            },
        },
        ".Mui-disabled::before": {
            borderBottomStyle: (_f = style === null || style === void 0 ? void 0 : style.borderBottomStyle) !== null && _f !== void 0 ? _f : "solid",
        },
        ".MuiAutocomplete-tag": {
            color: `${palette.grey080} !important`,
        },
        ".MuiAutocomplete-input::placeholder": {
            color: (readOnly && palette.grey060) || (disabled && palette.grey030) || palette.grey040,
            opacity: 1,
        },
    };
});
export function GrAutoComplete(p) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    const { multiple = false, label, fullWidth, required, disabled, size = "medium", helperText, error, style, tagLength, className, optionType = "checkbox", } = p;
    const [selectedValue, setSelectedValue] = (() => {
        if ("value" in p) {
            return [p.value, undefined];
        }
        return useState(p.defaultValue);
    })();
    const handleChange = (e, value, reason) => {
        var _a;
        const v = value;
        setSelectedValue && setSelectedValue(v);
        (_a = p.onChange) === null || _a === void 0 ? void 0 : _a.call(p, e, v, reason);
    };
    const getPlaceholder = () => {
        if (multiple) {
            if (selectedValue === null || selectedValue === undefined || (Array.isArray(selectedValue) && !selectedValue.length)) {
                return p.placeholder;
            }
        }
        else {
            if (!selectedValue)
                return p.placeholder;
        }
        return undefined;
    };
    return (_jsx(_Fragment, { children: _jsxs(GrStack, { className: "GrAutocomplete-wrapper", display: "inline-flex", flexDirection: (_a = label === null || label === void 0 ? void 0 : label.flexDirection) !== null && _a !== void 0 ? _a : "column", width: (_b = style === null || style === void 0 ? void 0 : style.width) !== null && _b !== void 0 ? _b : (fullWidth ? "100%" : "360px"), gap: (_c = label === null || label === void 0 ? void 0 : label.gap) !== null && _c !== void 0 ? _c : (((_d = label === null || label === void 0 ? void 0 : label.flexDirection) === null || _d === void 0 ? void 0 : _d.includes("row")) ? "24px" : "6px"), children: [(label === null || label === void 0 ? void 0 : label.text) && (_jsx(GrLabel, { style: {
                        margin: ((_e = label === null || label === void 0 ? void 0 : label.flexDirection) === null || _e === void 0 ? void 0 : _e.includes("row")) ? "6px 0 0 0" : "0",
                        padding: "0 2px",
                        ...label === null || label === void 0 ? void 0 : label.style,
                    }, required: required, disabled: disabled, text: label.text, size: ((_f = label === null || label === void 0 ? void 0 : label.flexDirection) === null || _f === void 0 ? void 0 : _f.includes("row")) ? size : "extraSmall" })), _jsxs(GrStack, { flexDirection: (_g = helperText === null || helperText === void 0 ? void 0 : helperText.flexDirection) !== null && _g !== void 0 ? _g : "column", gap: (_h = helperText === null || helperText === void 0 ? void 0 : helperText.gap) !== null && _h !== void 0 ? _h : "6px", width: "100%", children: [_jsx(StyledAutocomplete, { className: classNames("GrAutocomplete", className), id: p.id, readOnly: p.readOnly, disabled: p.disabled, multiple: multiple, limitTags: p.limitTags, options: (_j = p.options) !== null && _j !== void 0 ? _j : [], freeSolo: p.freeSolo, disableClearable: p.disableClearable, size: size, renderTags: (_k = p.renderTags) !== null && _k !== void 0 ? _k : (value => value.map((v, index) => {
                                var _a, _b, _c, _d, _e, _f;
                                return (_jsx(GrChip, { color: "grey", shape: "circle", size: size, label: ((_b = (_a = p.getOptionLabelFunc) === null || _a === void 0 ? void 0 : _a.call(p, v)) !== null && _b !== void 0 ? _b : String(v)).length > (tagLength !== null && tagLength !== void 0 ? tagLength : 15)
                                        ? ((_d = (_c = p.getOptionLabelFunc) === null || _c === void 0 ? void 0 : _c.call(p, v)) !== null && _d !== void 0 ? _d : String(v)).slice(0, tagLength !== null && tagLength !== void 0 ? tagLength : 15) + "..."
                                        : (_f = (_e = p.getOptionLabelFunc) === null || _e === void 0 ? void 0 : _e.call(p, v)) !== null && _f !== void 0 ? _f : String(v), variant: "soft", onDelete: p.readOnly || p.disabled
                                        ? undefined
                                        : e => {
                                            var _a;
                                            const value = (() => {
                                                if (multiple && Array.isArray(selectedValue)) {
                                                    return selectedValue.filter(el => el !== v);
                                                }
                                                else {
                                                    return undefined;
                                                }
                                            })();
                                            setSelectedValue && setSelectedValue(value);
                                            (_a = p.onChange) === null || _a === void 0 ? void 0 : _a.call(p, e, value, "removeOption");
                                        } }, index));
                            })), PaperComponent: props => (_jsx(Paper, { ...props, sx: {
                                    boxShadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.10)",
                                    padding: "0 4px",
                                } })), ListboxProps: { sx: { padding: "4px 0" } }, renderOption: (_l = p.renderOption) !== null && _l !== void 0 ? _l : ((props, option, { selected }) => {
                                var _a, _b, _c, _d;
                                return (_jsx(GrAutoCompleteOption, { props: props, type: optionType, text: (_b = (_a = p.getOptionLabelFunc) === null || _a === void 0 ? void 0 : _a.call(p, option)) !== null && _b !== void 0 ? _b : String(option), selected: selected, fullWidth: fullWidth, size: size, width: style === null || style === void 0 ? void 0 : style.width, multiple: p.multiple }, (_d = (_c = p.getOptionLabelFunc) === null || _c === void 0 ? void 0 : _c.call(p, option)) !== null && _d !== void 0 ? _d : String(option)));
                            }), getOptionDisabled: p.getOptionDisabled, filterOptions: p.filterOptions, renderInput: params => _jsx(TextField, { autoFocus: p.autoFocus, ...params, placeholder: getPlaceholder() }), fullWidth: p.fullWidth, inputValue: p.inputValue, value: (selectedValue !== null && selectedValue !== void 0 ? selectedValue : (multiple ? [] : null)), defaultValue: p.defaultValue, isOptionEqualToValue: p.optionMatcherFunc, onOpen: p.onOpen, onClose: p.onClose, disableCloseOnSelect: p.multiple, onChange: (e, value, r) => handleChange(e, value, r), onInputChange: p.onInputChange, onHighlightChange: p.onHighlightChange, onFocus: p.onFocus, onBlur: p.onBlur, popupIcon: _jsx(GrIcon, { type: "chevron-down", size: 16, color: p.disabled || p.readOnly ? "grey025" : "grey050" }), clearIcon: _jsx(GrTooltip, { content: "Clear", size: "small", arrow: false, children: _jsx(GrIconButton, { iconType: "x-mark", size: 14, color: p.disabled || p.readOnly ? "grey025" : "grey050" }) }), clearText: "", closeText: "", componentsProps: {
                                popper: {
                                    modifiers: [
                                        {
                                            name: "offset",
                                            options: {
                                                offset: [0, 5],
                                            },
                                        },
                                    ],
                                },
                                clearIndicator: {
                                    sx: {
                                        padding: 0,
                                    },
                                },
                            }, style: {
                                ...p.style,
                                caretColor: (_o = (_m = p.style) === null || _m === void 0 ? void 0 : _m.caretColor) !== null && _o !== void 0 ? _o : (error ? palette["negative-secondary"] : palette["maven-blue-dark"]),
                                borderColor: !((_p = p.style) === null || _p === void 0 ? void 0 : _p.border)
                                    ? (_r = (_q = p.style) === null || _q === void 0 ? void 0 : _q.borderColor) !== null && _r !== void 0 ? _r : (((disabled || p.readOnly) && `${palette.grey025} !important`) ||
                                        (error && palette["negative-secondary"]) ||
                                        palette.grey025)
                                    : undefined,
                            }, sx: {
                                ".MuiAutocomplete-endAdornment": {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                },
                            } }), (helperText === null || helperText === void 0 ? void 0 : helperText.text) && (_jsx(GrHelperMessage, { disabled: disabled, error: error, text: helperText.text, style: helperText === null || helperText === void 0 ? void 0 : helperText.style, hasIcon: helperText.hasIcon }))] })] }) }));
}
export function GrAutoCompleteOption(props) {
    const [hovered, setHovered] = useState(false);
    return (_jsxs("li", { ...props.props, onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false), style: {
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            padding: "10px",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            borderRadius: props.multiple ? undefined : "6px",
            backgroundColor: props.selected ? palette.blue015 : hovered ? palette.bg010 : palette.white,
            boxSizing: "border-box",
        }, children: [props.type === "checkbox" && (_jsx(GrStack, { margin: "0 6px 0 0", children: _jsx(GrCheckbox, { checked: props.selected, disabled: false, size: "medium", style: { padding: "0" } }) })), _jsx(StyledSelectOptionTypography, { size: "small", checked: props.selected, text: props.text })] }));
}
//# sourceMappingURL=GrAutocomplete.js.map